module.exports = __webpack_public_path__ + "media/honey-icons/icon-kitchen-1f3e505e.svg";